import { Action, createReducer, on } from '@ngrx/store'
import {
  delete_government_business_details,
  fetch_dashboard_data_success,
  fetch_government_business_details_success,
  load_government_business_summary_success_action
} from '../action/government-business.action'
import { GovernmentBusinessState, initialGovernmentState } from '../state/government-business.state'
import { GovernmentBusinessDashboardModel } from '../../models/model'

export function governmentBusinessReducer(state: GovernmentBusinessState, action: Action) {
  return _governmentBusinessReducer(state, action)
}

const _governmentBusinessReducer = createReducer(
  initialGovernmentState,
  on(fetch_dashboard_data_success, (state, { governmentBusinessPendingItemsList, statusCountMap }) => {
    const dashboardData: GovernmentBusinessDashboardModel = {
      governmentBusinessPendingItemsList,
      statusCountMap
    }
    return {
      ...state,
      dashboard: dashboardData
    }
  }),
  on(fetch_government_business_details_success, (state, { governmentBusiness }) => {
    return {
      ...state,
      details: governmentBusiness
    }
  }),
  on(delete_government_business_details, (state, {}) => {
    return {
      ...state,
      details: null
    }
  }),
  on(load_government_business_summary_success_action, (state, { governmentBusiness }) => {
    return {
      ...state,
      summary: governmentBusiness
    }
  })
)
